import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { AccessTime } from "@mui/icons-material";

const TimeExpiryDialog = ({
  open,
  onClose,
  onContinue,
  nextSection = "next section",
}) => {
  return (
    <Dialog
      open={open}
      onClose={undefined} // Disable click-outside-to-close - user must click button
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={true} // Disable ESC key to close
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <AccessTime color="error" sx={{ fontSize: 60 }} />
          <Typography variant="h5" fontWeight="bold" color="error">
            Time Expired
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 3, textAlign: "center" }}>
        <Typography variant="body1" paragraph>
          The timer for the previous section has ended.
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          You are now being directed to the {nextSection}.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 3, justifyContent: "center" }}>
        <Button
          onClick={onContinue}
          variant="contained"
          color="primary"
          size="large"
          sx={{ minWidth: 120 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeExpiryDialog;
